import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import Icon_house from '../../assets/images/service/house.png';
import Icon_building from '../../assets/images/service/Commercial Cleaning.png';
import Icon_deepclean from '../../assets/images/service/deep.png';
import Icon_outdoor from '../../assets/images/service/outdoor.png';



import Icon_landscape from '../../assets/images/service/landscape.png';
import Icon_growing from '../../assets/images/service/growing.png';
import Icon_harvest from '../../assets/images/service/harvest.png';
import Icon_flower from '../../assets/images/service/flower.png';
import Icon_tree from '../../assets/images/service/tree.png';
import Icon_rubbish from '../../assets/images/service/rubbish.png';
import { FaLongArrowAltRight } from 'react-icons/fa';

const ServiceData = [
    {


        id: uuidv4(),
        heading: 'Residential Cleaning',
        description: 'Complete home cleaning with eco-friendly products for spotless, healthy living spaces',
        img: Icon_house,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Commercial Cleaning',
        description: 'Professional office and workspace cleaning tailored to your business needs',
        img: Icon_building,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Deep Cleaning',
        description: 'Thorough cleaning of every corner, including hard-to-reach areas and appliances',
        img: Icon_deepclean,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Outdoor Area Cleaning',
        description: 'Specialized outdoor area cleaning including patios, decks and exterior surfaces',
        img: Icon_outdoor,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Landscape Design',
        description: ' Custom outdoor designs that transform your space with native plants, functional layouts, and aesthetic harmony',
        img: Icon_landscape,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Plant Growing',
        description: ' Expert cultivation using organic methods to ensure healthy, thriving plants tailored to your local climate',
        img: Icon_growing,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Branch Cutting',
        description: 'Precision pruning for tree health and safety, promoting growth while maintaining natural beauty',
        img: Icon_harvest,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Flower Scaping',
        description: 'Seasonal floral arrangements that create vibrant color displays with year-round visual interest',
        img: Icon_flower,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Tree Planting',
        description: 'Strategic tree placement and species selection for shade, privacy, and ecosystem benefits',
        img: Icon_tree,
        serviceLink: '/service-details',
    },
    {
        id: uuidv4(),
        heading: 'Rubbish Removal',
        description: 'Eco-friendly yard waste disposal with recycling and composting options for a cleaner property',
        img: Icon_rubbish,
        serviceLink: '/service-details',
    },

];

const ServiceItem = ({ img, heading, description, serviceLink }) => {
    return (
        <>
            <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="single-service">
                    <div className="service-icon">
                        <img src={img} alt="Service Icon" />
                    </div>
                    <h3>{heading}</h3>
                    <p>{description}</p>
                    <a href={serviceLink}>Explore More <FaLongArrowAltRight /></a>
                </div>
            </div>
        </>
    )
}

const Service = () => {
    return (
        <>
            <div className="service-area bg-4 pt-110 pb-110">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-70">
                                <span>Our Services</span>
                                <h2>Most in Demand <br/>Professional Cleaning & Landscape & Gardening services</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {ServiceData.map((data) => (
                            <ServiceItem
                                key={data.id}
                                img={data.img}
                                heading={data.heading}
                                description={data.description}
                                serviceLink={data.serviceLink}
                            />
                        ))}
                        <div className="col-xl-6 col-lg-12 col-md-12">
                            <div className="single-service-large">
                                <h3>We are professional <span> Cleaning, Landscaping and Gardening services</span></h3>
                                <p> For over Five years, our certified team has designed and maintained breathtaking outdoor environments. 
                                    We combine sustainable practices with artistic vision to create landscapes that thrive in all seasons, 
                                    while our tailored maintenance plans keep your property pristine year-round. </p>
                                <a href="/contact" className="l-btn">Appointment</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Service;